export class EntityHoliday {
public c_holiday_id:number | null = null;
public c_holiday_date:Date | null = null;
public c_holiday_name:string | null = null;
public c_holiday_reg_user:string | null = null;
public c_holiday_reg_at:Date | null = null;
public c_holiday_upd_user:string | null = null;
public c_holiday_upd_at:Date | null = null;
}